import Swal from "sweetalert2";

export const handleDocExtensions = (e) => {
  const supportedExtensions = ["pdf"];
  const input = e.target;
  const extension = input.value.split(".");
  if (!supportedExtensions.includes(extension[extension.length - 1]) && extension[extension.length - 1] !== "") {
    input.value = null;
    return Swal.fire({
      title: "Error",
      html: `
        <b>Éste campo solo recibe documentos de extensión tipo .pdf</b>
        <br/>
        <br/>
        <p style="text-align:left;">
        <b>*Si su archivo está comprimido en .rar o .zip</b>
        </p>
        <p style="text-align:justify;">
        1) Descomprima el archivo y observe que los archivos contenidos tengan los formatos admitidos. 
        </p>
        <p style="text-align:left;">
        <b>*Si su archivo es .jpg / .png </b>
        </p>
        <p style="text-align:justify;">
        1) Utilice la siguiente herramienta para covertirlo a los formatos admitidos y vueva a subirlo: 
        <br/>
        <a href="https://documento.online-convert.com/es/convertir-a-pdf">Convertidor a formato admitido</a>
        <br/>
        <p style="text-align:justify;">
        <span style="color:#007bff;">Importante</span><br/>
        Suba de a un archivo por vez y presione "iniciar conversión".<br/>
        Puede que en la parte superior le solicite un permiso seleccione "permitir", aguarde un instante y comenzará a descargar el archivo en formato admitido.<br/> 
        Repita el proceso con todos los archivos que necesite. 
        </p>
        `,
      icon: "error",
    });
  }
  return;
};

export const handleImageExtensions = (e) => {
  const supportedExtensions = ["jpg","png","jpeg"];
  const input = e.target;
  const extension = input.value.split(".");
  if (!supportedExtensions.includes(extension[extension.length - 1]) && extension[extension.length - 1] !== "") {
    input.value = null;
    return Swal.fire({
      title: "Error",
      html: `
        <b>Éste campo solo recibe imágenes de extensión tipo .jpg / .png</b>
        <br/>
        <br/>
        <p style="text-align:left;">
        <b>*Si su archivo está comprimido en .rar o .zip</b>
        </p>
        <p style="text-align:justify;">
        1) Descomprima el archivo y observe que los archivos contenidos tengan los formatos admitidos. 
        </p>
        <p style="text-align:left;">
        <b>*Si su archivo es .jpeg</b>
        </p>
        <p style="text-align:justify;">
        1) Utilice la siguiente herramienta para covertirlo a formato admitido y vueva a subirlo: 
        <br/>
        <a href="https://imagen.online-convert.com/es/convertir/jpeg-a-jpg">Convertidor a formato .jpg</a>
        <br/>
        <span style="color:#007bff;">Importante</span><br/>
        Suba de a un archivo por vez y presione "iniciar conversión".<br/>
        Puede que en la parte superior le solicite un permiso, seleccione "permitir", aguarde un instante y comenzará a descargar el archivo en formato admitido.<br/> 
        Repita el proceso con todos los archivos que necesite. 
        </p>
        <p style="text-align:left;">
        <b>*Si su archivo es .pdf</b>
        </p>
        <p style="text-align:justify;">
        1) Utilice la siguiente herramienta para covertirlo a los formatos admitidos y vueva a subirlo: 
        <br/>
        <a href="https://imagen.online-convert.com/es/convertir/pdf-a-jpg">Convertidor a formato admitido</a>
        <br/>
        <p style="text-align:justify;">
        Siga instrucciones de *<span style="color:#007bff;">Importante</span><br/> de la sección .jpeg
        </p>
        `,
      icon: "error",
    });
  }
  return;
};

export const handleFileExtensions = (e) => {
  const supportedExtensions = ["pdf", "jpg", "png"];
  const input = e.target;
  const extension = input.value.split(".");
  if (!supportedExtensions.includes(extension[extension.length - 1]) && extension[extension.length - 1] !== "") {
    input.value = null;
    return Swal.fire({
      title: "Error",
      html: `
        <b>Éste campo recibe imágenes y documentos de extensión tipo .pdf / .jpg / .png</b>
        <br/>
        <br/>
        <p style="text-align:left;">
        <b>*Si su archivo está comprimido en formato .rar o .zip</b>
        </p>
        <p style="text-align:justify;">
        Descomprima el archivo y observe que los archivos contenidos tengan los formatos admitidos. 
        </p>
        `,
      icon: "error",
    });
  }
  return;
};

export const handleFileSize = (e) => {
  const input = e.target;
  const files = input.files;
  const maxAllowedSize = 1048576 // 1*1024*1024 = 1 Mb
  let totalSize = 0
  for (let index in files) {
    if (files[index].size) {
      totalSize += files[index].size
    }
  }
  if (totalSize > maxAllowedSize*files?.length) {
    input.value = null;
    return Swal.fire({
      title: "Error",
      html: `
      <br/>
      <b>No es posible subir archivos mayores a 1 Mb</b>. 
      <br/>
      <br/>
      <p style="width:100%; text-align:justify;"><b>*Si subió un archivo .png/.jpg:</b></p>
      <p style="width:100%; text-align:justify;">1) Utilice la siguiente herramienta para reducir el tamaño del archivo:
      <a href="https://tinypng.com/">Reductor .png/.jpg</a>
      <p style="width:100%; text-align:justify;">2) Si aún así supera el tamaño intente escanear el documento con una menor resolución y vuelva a intentarlo.
      </p>
      <p style="width:100%; text-align:justify;"><b>*Si subió un archivo .pdf </b></p>
      <p style="width:100%; text-align:justify;">1) Utilice la siguiente herramienta para reducir su tamaño: <a href="https://tools.pdf24.org/es/comprimir-pdf">Reductor PDF</a>.
      <br/>
      <br/>
      2) Si después de reducirlo el tamaño sigue siendo mayor al admitido, utilice la configuración DPI:60 en la parte inferior izquierda del cuadro. Si sigue siendo mayor, como último intento utilice DPI:40.<br/> <span style="color:#007bff;">Importante:</span> Revise que el documento sea legible.
      <br/>
      <br/>
      3) Si aún así supera el tamaño intente escanear el documento con una menor resolución y vuelva a intentarlo.</span>`,
      icon: "error",
    });
  }
  return;
};